













































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { GetRightsList, GetSpaceRights } from '../api/common/index';

@Component({
  components: {},
})
export default class Index extends Vue {
  rightList = {};
  spaceRight = {};
  mounted() {
    GetRightsList({ isBindGive: false }).then(res => {
      this.rightList = res;
    });
    GetSpaceRights().then(res => {
      this.spaceRight = res;
    });
  }

  buy(item: any, can: boolean) {
    if (can) {
      window.open(`https://nu29069382.mallfkw.net/`, '_blank');

      // window.open(`https://nu29069382.mallfkw.net/pd.jsp?id=${item.commodityId}`, '_blank');
    }
  }
}
